import type { DeliverySelection } from '~/components/common/delivery-run-panel';

import { candidateKeysFor, type DeliveredFieldStatus } from './delivery-field-keys';

/**
 * Pre-delivery counterpart to `deliveredFieldStatus`: classifies a field's
 * PROPOSED outcome from the operator's not-yet-submitted attribute selection
 * instead of a real delivered-payload lookup. Only `'sent'`/`'not_sent'` ever
 * occur here — `'truncated'`/`'failed'`/`'unknown'` describe an attempt that
 * hasn't happened yet. Google and Meta both honour the selection, so the
 * classification is platform-agnostic.
 */
export function computeProposedFieldStatus(
  field: string,
  selection: DeliverySelection,
): DeliveredFieldStatus {
  if (selection.decision !== 'APPROVED') return 'not_sent';
  const selected = new Set(selection.attributeKeys);
  return candidateKeysFor(field).some((key) => selected.has(key)) ? 'sent' : 'not_sent';
}
